var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-loading',{attrs:{"is-full-page":false,"active":_vm.isLoading}}),_c('canvas',{ref:"canvas"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }